import styled from 'styled-components'

const BUTTON_WIDTH = 350

export const Wrapper = styled.div`
  .text-wrapper {
    & > a {
      ${({ theme }) => theme.below.tablet`
          width: ${BUTTON_WIDTH}px;
          max-width: 100%;
      `}
    }
  }
`
